import React from 'react';
import './AmenidadesDesc.scss';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import "animate.css/animate.min.css";
import { useTranslation } from 'react-i18next';

const AmenidadesDescCopal = () => {
  const { t } = useTranslation();

  return (
    <>
      <div id="amenmapa" className='contenedor_amenidades_desc_copal'>
        <img className='contenedor_amenidades_desc_fondo_copal' src="/assets/img-velasur-privada-acacia.jpg" alt="" />
        <div className='contenedor_amenidades_desc__slider_card'>
          <AnimationOnScroll
            duration={2}
            animateOnce={true}
            animateIn='animate__fadeIn'>
            <div className='contenedor_amenidades_desc__slider_card_logo_copal'>
              <img src="/assets/logo-P-COPAL.png" alt="Logo Copal" />
            </div>
          </AnimationOnScroll>
          <div className='contenedor_amenidades_desc__slider_card_metros_copal'>
            <p>{t('amenitiesDescCopal.lots')}</p>
          </div>
          <div className='contenedor_amenidades_desc__slider_card_lista_copal'>
            <div className='amenidad_copal'>
              <div>
                <img src="/assets/Iconos/svg-icon-iso.svg" alt="icono" />
                <p>{t('amenitiesDescCopal.clubhouse')}</p>
              </div>
            </div>
            <div className='amenidad_copal'>
              <div>
                <img src="/assets/Iconos/svg-icon-iso.svg" alt="icono" />
                <p>{t('amenitiesDescCopal.greenArea')}</p>
              </div>
            </div>

            <div className='amenidad_copal'>
              <div>
                <img src="/assets/Iconos/svg-icon-iso.svg" alt="icono" />
                <p>{t('amenitiesDescCopal.privatePool')}</p>
              </div>
            </div>
            <div className='amenidad_copal'>
              <div>
                <img src="/assets/Iconos/svg-icon-iso.svg" alt="icono" />
                <p>{t('amenitiesDescCopal.controlledAccess')}</p>
              </div>
            </div>

            <div className='amenidad_copal'>
              <div>
                <img src="/assets/Iconos/svg-icon-iso.svg" alt="icono" />
                <p>{t('amenitiesDescCopal.recreationalAreas')}</p>
              </div>
            </div>
          </div>
          <div className='button_dispon_copal'>
            <a href='https://disponibilidad.velasur.mx/privada-copal'>
              {t('amenitiesDescCopal.seeAvailability')}
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default AmenidadesDescCopal;
